import http, { AUTH_ROUTES } from "../../../services/api";

// Always the authenticated endpoint — the resident frontend never depends on
// the unauthenticated public-verify endpoint for status or token delivery
// (Checkpoint 2B2 Final Closure). Callers must ensure the resident is signed
// in before invoking this; TopUp/index.jsx gates on that.
export const verifyPayment = async (payload) => {
  const result = await http.post(AUTH_ROUTES.VERIFY_PAYMENT, payload);
  return result;
};
